<script setup lang="ts">
/**
 * Root application component
 * Provides router outlet for navigation
 */
import NavBar from './components/NavigationBar.vue'
import Toast from './components/Toast.vue'
import ConfirmModal from './components/ConfirmModal.vue'
</script>

<template>
  <div id="app">
    <NavBar />
    <div class="">
      <router-view />
    </div>
    <Toast />
    <ConfirmModal />
  </div>
</template>

<style>
/* Global styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #ffffff;
  background-color: #000000;
  padding: 0;
  margin: 0;
}


/* App-wide container */
.container {
  width: 100%;
  /* max-width: 1600px;           */
  margin-left: auto;
  margin-right: auto;
  /* padding-left: clamp(1rem, 4vw, 2rem);   
  padding-right: clamp(1rem, 4vw, 2rem);   */
  box-sizing: border-box;
}
</style>
